module.exports = __webpack_public_path__ + "img/understanding-my-data-h.57cd0cbc.png";